import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { createAsyncMetaSelectors, createScopedSelector } from '@mews/framework';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { reservationsKey } from '../../reducers';
import { parentSelector } from './parentSelector';

const getReservationsState = createSelector(parentSelector, get(reservationsKey));
const getReservationsScope = createScopedSelector({
    parentSelector: getReservationsState,
    initialState: META_STATE_SUCCEEDED,
});

const getReservationsMeta = createSelector(getReservationsScope, get(['meta']));

export const [areReservationsFetching, haveReservationsFailed] = createAsyncMetaSelectors(getReservationsMeta);
